export default __webpack_public_path__ + "static/media/datacenter.4958a2b2.svg";